






































import { computed, defineComponent }  from '@vue/composition-api';
import cLoginHeader                   from '@/views/login/components/login-header/login-header.component.vue';
import cButton                        from '@/components/form/button/button.component.vue';
import { name as vLogin }             from '@/views/login/login.route';
import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import useGlobalTranslations          from '@/hooks/use-global-translations';
import { Computed }                   from '@/types';
import { TranslateResult }            from 'vue-i18n';

export default defineComponent({
  name: 'vCookiePolicy',
  components: {
    cLoginHeader,
    cButton,
  },
  setup() {
    const { i18n, router }: GlobalContexts = useGlobals();
    const buttonAccept = useGlobalTranslations('buttons.accept');

    const setCookieFromView = async (): Promise<void> => {
      await router.push({ name: vLogin });
    };

    const cookieArticles: Computed<TranslateResult> = computed(() => i18n.t('vCookiePolicy.content.article'));

    return {
      i18n,
      setCookieFromView,
      cookieArticles,
      buttonAccept,
    };
  },
});
